var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"layout-body"},[_c('layout-sider'),_c('div',{staticClass:"layout-main"},[_c('div',{staticClass:"layout-header"},[_c('page-path'),_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.handleLogout}},[_vm._v("退出登录")])],1),_c('div',{staticClass:"layout-content"},[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }